import { render, staticRenderFns } from "./MyGridVuetify.vue?vue&type=template&id=4bb5adab&scoped=true&"
import script from "./MyGridVuetify.vue?vue&type=script&lang=js&"
export * from "./MyGridVuetify.vue?vue&type=script&lang=js&"
import style1 from "./MyGridVuetify.vue?vue&type=style&index=1&id=4bb5adab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb5adab",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VApp,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb5adab')) {
      api.createRecord('4bb5adab', component.options)
    } else {
      api.reload('4bb5adab', component.options)
    }
    module.hot.accept("./MyGridVuetify.vue?vue&type=template&id=4bb5adab&scoped=true&", function () {
      api.rerender('4bb5adab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyGridVuetify.vue"
export default component.exports